import { SpotCampaignContentProps } from '@websrc/Spot/Campaign/Components/SpotCampaignContent'
import React from 'react'

import * as SC from './SpotCampaignAsset.style'

export const SpotCampaignAsset: React.FC<SpotCampaignContentProps> = ({
  spot,
  hasVideo,
  imageLazy,
  bgColor,
}) => (
  <SC.SpotAsset
    bgColor={bgColor}
    isBackgroundVideo={spot.is_background_image && hasVideo}
    lazyLoading={imageLazy}
    sizes={`(max-width: 1900px) ${spot.is_background_image ? '95vw' : '60vw'}, 600px`}
    srcSetWidths={[600, 900, 1200]}
    {...spot.asset}
  />
)
